
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 40.5a4.5 4.5 0 014.5-4.5H39V6H13.5A4.5 4.5 0 009 10.5v30z","stroke":"#000C1F","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30 21l-9-6v12l9-6z","stroke":"#3DAFB8","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9 40.5V42h27","stroke":"#000C1F","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    